import { gql } from "@apollo/client";

export const getSiteIncidentQuery = gql`
    query($input: SiteIncidentFilter!){
        getSiteIncidents(input: $input) {
            currentPage
            message
            totalCount
            totalPages
            response
        }
    }
`;

export const getSiteIncidentReportDetail = gql`
query($id: String!){
  getSiteIncidentDetail(_id: $id) {
    message
    response
  }
}
`;